// extracted by mini-css-extract-plugin
export default {"headerLogIn":"Header_headerLogIn__i+4i-","Headerlogo":"Header_Headerlogo__aK7z4","headerButton":"Header_headerButton__KGvCu"};